/* eslint-disable react/require-default-props */
import React, { FC, ReactElement } from 'react';
import { ValidIconMaterialName } from '@abyss/web/ui/IconMaterial';
import { ResultsStatus } from '../../types';
import { ResultsPending } from './ResultsPending';
import { ResultsSearching } from './ResultsSearching';
import { ResultsNone } from './ResultsNone';
import { ResultsError } from './ResultsError';

interface Props {
  id: string;
  status: ResultsStatus;
  iconPending: ValidIconMaterialName;
  SuccessComp: ReactElement;
  ExcessiveComp?: ReactElement;
  UnmanageableComp?: ReactElement;
}

export const SearchResults: FC<Props> = ({
  status,
  id,
  iconPending,
  SuccessComp,
  ExcessiveComp,
  UnmanageableComp,
}) => {
  if (status === ResultsStatus.pendingSearch) {
    return <ResultsPending id={id} icon={iconPending} />;
  }

  if (status === ResultsStatus.searching) {
    return <ResultsSearching id={id} />;
  }

  if (status === ResultsStatus.noResults) {
    return <ResultsNone id={id} />;
  }

  if (status === ResultsStatus.error) {
    return <ResultsError id={id} />;
  }

  if (status === ResultsStatus.excessiveResults && ExcessiveComp) {
    return ExcessiveComp;
  }

  if (status === ResultsStatus.unmanageableResults && UnmanageableComp) {
    return UnmanageableComp;
  }

  return SuccessComp;
};
